import PropTypes from 'prop-types';
import DatasourceBaseOauthNew from "../Datasources/DatasourceBaseOauthNew.jsx";

const DatasourceBusinessCentral = (props) => {

    const ClientId = "d2b5e92c-dadf-4d33-9dab-b6b5517f8773"
    const Scope = "offline_access+https://api.businesscentral.dynamics.com/user_impersonation"
    const RedirectUrl = "https://auth.cloudcti.nl/webapi/oauth2"
    const AuthUrl = "https://login.microsoftonline.com/common/oauth2/v2.0/authorize?scope=" + Scope + "&client_id=" + ClientId + "&response_type=code&response_mode=query&redirect_uri=" + RedirectUrl

    return <DatasourceBaseOauthNew SecurityToken={props.SecurityToken} DatasourceData={props.DatasourceData} IntegrationSettings={props.IntegrationSettings} AuthUrl={AuthUrl} CrmServerTokenController="/api/businesscentral/tokens" OnSetReady={props.OnSetReady}/>
}

DatasourceBusinessCentral.propTypes = {
    SecurityToken: PropTypes.string,
    DatasourceData: PropTypes.object,
    IntegrationSettings: PropTypes.object,
    OnSetReady: PropTypes.func
}   

export default DatasourceBusinessCentral